import React from 'react';
import PropTypes from 'prop-types';

import {Button, Grid} from '@mui/material';
import {withTheme} from '@mui/styles';

import CompactTextField from '../CompactTextField';

class FixLoginControl extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			client_id: '',
			client_secret: '',
		};
		this.onSubmit = props.onSubmit;
	}

	valueChanged(name) {
		return (event) => {
			this.setState({ [name]: event.target.value });
		};
	}

	submit() {
		this.onSubmit(this.state.client_id, this.state.client_secret);
	}

	renderTab() {
		return (
			<React.Fragment>
				<CompactTextField
					type="text"
					value={this.state.client_id}
					onChange={this.valueChanged('client_id')}
					id="client-id-field"
					label="Client ID"
				/>
				<CompactTextField
					type="text"
					value={this.state.client_secret}
					onChange={this.valueChanged('client_secret')}
					id="client-secret-field"
					label="Client Secret"
					onKeyDown={(e) => {
						if (e.keyCode === 13) { // enter
							this.submit();
						}
					}}
				/>
				<Grid container justifyContent="end">
					<Button variant="contained" color="primary" style={{ marginTop: 8 }}
						onClick={() => {
							this.submit();
						}}
					>
						Login
					</Button>
				</Grid>
			</React.Fragment>
		);
	}

	render() {
		return (
			<div style={{ display: 'flex', flexFlow: 'column', height: '100%', overflow: 'hidden', background: this.props.theme.palette.background.paper }}>
				<div style={{ overflow: 'auto', flex: '1 1 auto' }}>
					<Grid container direction="column" justifyContent="center" alignItems="stretch" style={{ padding: '8px', borderBottom: this.props.theme.border }}>
						<Grid container item direction="row" alignItems="center" spacing={2}>
						</Grid>
						<Grid container item direction="row" alignItems="center" spacing={2}>
						</Grid>
					</Grid>
					<div style={{ padding: 8}}>{this.renderTab()}</div>
				</div>
			</div>
		);
	}
}

export default withTheme(FixLoginControl);

FixLoginControl.propTypes = {
	onSubmit: PropTypes.func,
	theme: PropTypes.object,
};
